<script setup>
import { onMounted, ref, computed } from 'vue';
import axios from '@/plugins/axios';

const creditsBalance = ref(null);
const lastSaleWithCredits = ref([])
const creditsUsed = ref(0)

const fetchCredits = async () => {
    const response = await axios.get('/api/users/credits')
    if(response.data) {
        creditsBalance.value = response.data.toFixed(2);
    }
}

const fetchCreditsHistory = async () => {
    const response = await axios.get('/api/users/credits-history')
    lastSaleWithCredits.value = response.data.slice(0, 2);
    creditsUsed.value = response.data.reduce((acc, item) => acc + Number(item.amount), 0);
}

const percentageUsedCredits = computed(() => {
    const allCredits = Number(creditsBalance.value) + Number(creditsUsed.value);
    return (creditsUsed.value * 100) / allCredits;
})

const percentageRemainingCredits = computed(() => {
    return 100 - percentageUsedCredits.value;
})


onMounted(async () => {
    await fetchCredits();
    await fetchCreditsHistory();
});
</script>

<template>
    <div class="credits-card" v-if="creditsBalance !== null">
        <div class="credits-info">
            <h2 class="text-lg font-bold">Platform Credits</h2>
            <p class="usage-text">Use credits on select dataset purchases</p>
        </div>
        <div class="flex gap-4">
            <div class="credits-main">
                <div class="credits-circle-container">
                    <div class="credits-circle">
                        <svg class="progress-ring" width="100" height="100">
                            <circle
                                class="progress-ring-circle-bg"
                                stroke="currentColor"
                                stroke-width="6"
                                fill="transparent"
                                r="42"
                                cx="50"
                                cy="50"
                            />
                            <circle
                                class="progress-ring-circle"
                                stroke="currentColor"
                                stroke-width="6"
                                fill="transparent"
                                r="42"
                                cx="50"
                                cy="50"
                                :stroke-dasharray="264"
                                :stroke-dashoffset="264 - (264 * percentageRemainingCredits) / 100"
                            />
                        </svg>
                        <div class="credits-value">
                            <span class="credits-amount">{{ creditsBalance }}</span>
                            <span class="credits-label">credits</span>
                        </div>
                    </div>
                </div>

              
            </div>


        </div>
      
    </div>
</template>

<style scoped lang="postcss">
.credits-card {
    @apply w-full flex items-center justify-between;
}

.credits-header {
    @apply flex items-center gap-2 mb-2;
}

.header-icon {
    @apply w-6 h-6 bg-emerald-600 dark:bg-emerald-500 
           text-white dark:text-white 
           rounded-full flex items-center justify-center mt-1;
}

.header-title {
    @apply text-lg font-bold text-white;
}

.credits-main {
    @apply text-center;
}

.credits-circle-container {
    @apply relative flex justify-center;
}

.credits-circle {
    @apply relative;
}

.progress-ring {
    @apply transform -rotate-90;
}

.progress-ring-circle-bg {
    @apply text-echoes-border-light;
}

.progress-ring-circle {
    @apply transition-all duration-700 ease-out text-emerald-600 dark:text-emerald-500;
}

.credits-value {
    @apply absolute inset-0 flex flex-col items-center justify-center;
}

.credits-amount {
    @apply font-bold text-white/80;
}

.credits-label {
    @apply text-sm text-white/80 -mt-1;
}


.usage-text {
    @apply text-sm text-white/80 font-medium;
}

.usage-header {
    @apply flex items-center gap-2 mb-1;
}

.usage-title {
    @apply text-sm font-medium text-white/80 pb-1;
}

.usage-list {
    @apply space-y-2;
}

.usage-item-main {
    @apply flex items-start gap-3;
}

.usage-item-icon {
    @apply w-5 h-5 text-emerald-600 dark:text-emerald-500 mt-0.5;
}

.usage-item-info {
    @apply flex-1 min-w-0;
}

.usage-item-name {
    @apply block text-sm font-medium text-white/80 
           hover:text-emerald-600 dark:hover:text-emerald-400 
           transition-colors duration-200 truncate;
}

.usage-item-amount {
    @apply text-xs text-white/80;
}

.usage-item-details {
    @apply flex flex-col items-start justify-between ;
}

.usage-item-date {
    @apply text-xs text-white/80;
}

.user-item-grid {
    @apply grid grid-cols-12 space-x-2;
}
/* Animations */
@keyframes draw {
    from {
        stroke-dashoffset: 264;
    }
    to {
        stroke-dashoffset: var(--target-offset);
    }
}
</style>